import { persistReducer } from 'redux-persist'

import {
    reducer as pageStoreLocatorReducer,
    type State as StoreLocatorPageState
} from 'shared/store/store-locator'
import {
    reducer as pageHomeReducer,
    type State as HomePageState
} from 'shared/store/homepage'
import {
    reducer as applicationReducer,
    type State as ApplicationState
} from 'shared/store/application'
import {
    reducer as franchisePageReducer,
    type State as FranchisePageState
} from 'shared/store/franchise'
import {
    reducer as familyPageReducer,
    type State as FamilyPageState
} from 'shared/store/family'
import {
    reducer as tuPreferesKingReducer,
    type TPKState
} from 'shared/store/tu-preferes-king'
import {
    reducer as i18nReducer,
    type State as I18nState
} from 'shared/store/i18n'
import type { State as ProductPageState } from 'shared/store/product'
import { productPageReducer } from 'shared/store/product'
import {
    reducer as metaDataReducer,
    type State as MetaDataState
} from 'shared/store/metadata'
import {
    reducer as categoriesPageReducer,
    type State as CategoriesPageState
} from 'shared/store/catalog'
import {
    reducer as notFoundPageReducer,
    type State as notFoundPageState
} from 'shared/store/not-found'
import { reducer as uiReducer, type State as UIState } from 'shared/store/ui'
import {
    reducer as faqPageReducer,
    type State as FaqPageState
} from 'shared/store/faq'
import {
    reducer as userReducer,
    type State as UserState
} from 'shared/store/user'
import {
    reducer as customPageReducer,
    type State as CustomPageState
} from 'shared/store/custom'
import {
    reducer as timelinePageReducer,
    type State as TimelinePageState
} from 'shared/store/timeline'
import { reducer as orbReducer, type State as OrbState } from 'shared/store/orb'
import {
    reducer as rootPageReducer,
    type RootState as RootPageState
} from 'shared/store/root'
import {
    reducer as signupPageReducer,
    type State as SignupPageState
} from 'shared/store/signup'
import {
    reducer as signinPageReducer,
    type State as SigninPageState
} from 'shared/store/signin'
import {
    reducer as congratulationsPageReducer,
    type State as CongratulationsPageState
} from 'shared/store/congratulations'
import {
    reducer as resetPasswordPageReducer,
    type State as ResetPasswordPageState
} from 'shared/store/reset-password'
import {
    reducer as kingdomDashboardPageReducer,
    type State as KingdomDashboardPageState
} from 'shared/store/kingdom/dashboard'
import {
    reducer as kingdomProfilePageReducer,
    type State as KingdomProfilePageState
} from 'shared/store/kingdom/profile'
import {
    reducer as kingdomCardPageReducer,
    type State as KingdomCardPageState
} from 'shared/store/kingdom/card'
import {
    reducer as kingdomBlazonsPageReducer,
    type State as KingdomBlazonsPageState
} from 'shared/store/kingdom/blazons'
import {
    reducer as kingdomPrivilegesPageReducer,
    type State as KingdomPrivilegesPageState
} from 'shared/store/kingdom/privileges'
import {
    reducer as kingdomLotteryPageReducer,
    type State as KingdomLotteryPageState
} from 'shared/store/kingdom/lottery'
import {
    reducer as deliveryPageReducer,
    type State as DeliveryPageState
} from 'shared/store/delivery'
import {
    reducer as mysteryBurgerPageReducer,
    type State as MysteryBurgerPageState
} from 'shared/store/custom-operation/mystery-burger'
import {
    reducer as restaurantPageReducer,
    type State as RestaurantPageState
} from 'shared/store/restaurant'
import {
    reducer as notationPageReducer,
    type State as NotationPageState
} from 'shared/store/notation'
import {
    reducer as democraticBurgerPageReducer,
    type State as DemocraticBurgerPageState
} from 'shared/store/custom-operation/democratic-burger'
import {
    reducer as birthdayPageReducer,
    type State as BirthdayPageState
} from 'shared/store/birthday'
import {
    reducer as genericOperationPageReducer,
    type State as GenericOperationPageState
} from 'shared/store/custom-operation/generic'
import {
    reducer as kingdomPointsPageReducer,
    type State as KingdomPointsPageState
} from 'shared/store/kingdom/points'
import {
    reducer as featuresReducer,
    type State as FeaturesState
} from 'shared/store/features'
import {
    reducer as ecommerceOrderReducer,
    type State as EcommerceOrderState
} from 'shared/store/ecommerce/order'
import {
    reducer as ecommerceCatalogReducer,
    type State as EcommerceCatalogState
} from 'shared/store/ecommerce/catalog'
import {
    reducer as satisfactionPageReducer,
    type State as SatisfactionPageState
} from 'shared/store/satisfaction'
import {
    reducer as futureWhopperPageReducer,
    type State as futureWhopperPageState
} from 'shared/store/operation/future-whopper'
import {
    reducer as veggieKingPageReducer,
    type State as veggieKingPageState
} from 'shared/store/veggie-king'
import {
    reducer as dealsPageReducer,
    type State as dealsPageState
} from 'shared/store/deals'

import {
    reducer as dealsWinningFormReducer,
    type State as dealsWinningFormPageState
} from 'shared/store/deals/winning-form'
import {
    reducer as menuPageReducer,
    type State as MenuPageState
} from 'shared/store/menu'

export type RootState = {
    i18nState: I18nState,
    applicationState: ApplicationState,
    homePageState: HomePageState,
    franchisePageState: FranchisePageState,
    productPageState: ProductPageState,
    familyPageState: FamilyPageState,
    storeLocatorPageState: StoreLocatorPageState,
    metaDataState: MetaDataState,
    uiState: UIState,
    notFoundPageState: notFoundPageState,
    categoriesPageState: CategoriesPageState,
    faqPageState: FaqPageState,
    userState: UserState,
    customPageState: CustomPageState,
    timelinePageState: TimelinePageState,
    rootPageState: RootPageState,
    orbState: OrbState,
    signupPageState: SignupPageState,
    signinPageState: SigninPageState,
    congratulationsPageState: CongratulationsPageState,
    resetPasswordPageState: ResetPasswordPageState,
    kingdomCardPageState: KingdomCardPageState,
    kingdomDashboardPageState: KingdomDashboardPageState,
    kingdomProfilePageState: KingdomProfilePageState,
    kingdomBlazonsPageState: KingdomBlazonsPageState,
    kingdomPrivilegesPageState: KingdomPrivilegesPageState,
    kingdomLotteryPageState: KingdomLotteryPageState,
    kingdomPointsPageState: KingdomPointsPageState,
    deliveryPageState: DeliveryPageState,
    mysteryBurgerPageState: MysteryBurgerPageState,
    restaurantPageState: RestaurantPageState,
    notationPageState: NotationPageState,
    democraticBurgerPageState: DemocraticBurgerPageState,
    birthdayPageState: BirthdayPageState,
    genericOperationPageState: GenericOperationPageState,
    featuresState: FeaturesState,
    ecommerceOrderState: EcommerceOrderState,
    ecommerceCatalogState: EcommerceCatalogState,
    satisfactionPageState: SatisfactionPageState,
    futureWhopperPageState: futureWhopperPageState,
    veggieKingPageState: veggieKingPageState,
    dealsPageState: dealsPageState,
    dealsWinningFormPageState: dealsWinningFormPageState,
    menuPageState: MenuPageState,
    tuPreferesKingState: TPKState,
    router: {
        location: {
            pathname: string,
            search: string,
            hash: string,
            key: string,
            state: any
        },
        action: string
    },
    nav: any
}

const createRootReducer = (storage: any) => {
    const homePersistReducer = persistReducer(
        {
            key: 'homePageState',
            storage,
            blacklist: ['error', 'networkError']
        },
        pageHomeReducer
    )

    const franchisePersistReducer = persistReducer(
        {
            key: 'franchisePageState',
            storage,
            blacklist: ['error', 'networkError']
        },
        franchisePageReducer
    )

    const familyPersistReducer = persistReducer(
        {
            key: 'familyPageState',
            storage,
            blacklist: ['error', 'networkError']
        },
        familyPageReducer
    )

    const notFoundPersistReducer = persistReducer(
        {
            key: 'notFoundPageState',
            storage,
            blacklist: ['error', 'networkError']
        },
        notFoundPageReducer
    )

    const faqPersistReducer = persistReducer(
        {
            key: 'faqPageState',
            storage,
            blacklist: [
                'error',
                'networkError',
                'sendFormError',
                'selectedTheme'
            ]
        },
        faqPageReducer
    )

    const rootPersistReducer = persistReducer(
        {
            key: 'rootPageState',
            storage,
            blacklist: ['dataLoaded', 'error', 'networkError']
        },
        rootPageReducer
    )

    const orbPersistReducer = persistReducer(
        {
            key: 'orbPageState',
            storage,
            blacklist: ['error', 'networkError']
        },
        orbReducer
    )

    const signupPersistReducer = persistReducer(
        {
            key: 'signupPageState',
            storage,
            blacklist: ['error', 'networkError', 'sendFormError']
        },
        signupPageReducer
    )

    const signinPersistReducer = persistReducer(
        {
            key: 'signinPageState',
            storage,
            blacklist: ['error', 'networkError', 'sendFormError']
        },
        signinPageReducer
    )

    const kingdomCardPersistReducer = persistReducer(
        {
            key: 'kingdomCardPageState',
            storage,
            blacklist: ['cardError', 'cardNetworkError']
        },
        kingdomCardPageReducer
    )

    const kingdomDashboardPersistReducer = persistReducer(
        {
            key: 'kingdomDashboardPageState',
            storage,
            blacklist: ['dashboardError', 'dashboardNetworkError']
        },
        kingdomDashboardPageReducer
    )

    const kingdomProfilePersistReducer = persistReducer(
        {
            key: 'kingdomProfilePageState',
            storage,
            blacklist: [
                'addKidError',
                'addKidSuccess',
                'addRestaurantError',
                'addRestaurantSuccess',
                'deleteKidError',
                'deleteProfileError',
                'profileError',
                'profileNetworkError',
                'profileUpdateError',
                'profileUpdateSuccess',
                'updatePasswordError',
                'updatePasswordSuccess'
            ]
        },
        kingdomProfilePageReducer
    )

    const kingdomBlazonsPersistReducer = persistReducer(
        {
            key: 'kingdomBlazonsPageState',
            storage,
            blacklist: ['blazonsError', 'blazonsNetworkError']
        },
        kingdomBlazonsPageReducer
    )

    const kingdomPrivilegesPersistReducer = persistReducer(
        {
            key: 'kingdomPrivilegesPageState',
            storage,
            blacklist: [
                'privilegesError',
                'privilegesNetworkError',
                'addCouponError'
            ]
        },
        kingdomPrivilegesPageReducer
    )

    // more info : BE-6655
    // const kingdomLotteryPersistReducer = persistReducer(
    //     {
    //         key: 'kingdomLotteryPageState',
    //         storage,
    //         blacklist: ['error', 'networkError']
    //     },
    //     kingdomLotteryPageReducer
    // )

    const deliveryPersistReducer = persistReducer(
        {
            key: 'deliveryPageState',
            storage,
            blacklist: ['error', 'networkError']
        },
        deliveryPageReducer
    )

    const userPersistReducer = persistReducer(
        {
            key: 'userState',
            storage,
            whitelist: [
                'cookiesConsents',
                'cookiesConsentsDone',
                'manageCookies',
                'trackingStatus',
                'notificationsConsentDate',
                'token',
                'authenticated',
                'userData',
                'appBannerClosed',
                'touchID',
                'signinDone',
                'analyticsData',
                'answeredGeofenceAccess',
                'geofenceAllowed',
                'optinPush'
            ],
            blacklist: ['error']
        },
        userReducer
    )

    const customPersistReducer = persistReducer(
        {
            key: 'customPageState',
            storage,
            blacklist: ['error', 'networkError']
        },
        customPageReducer
    )

    const mysteryBurgerPersistReducer = persistReducer(
        {
            key: 'mysteryBurgerPageState',
            storage,
            blacklist: ['error', 'networkError']
        },
        mysteryBurgerPageReducer
    )

    const notationPersistReducer = persistReducer(
        {
            key: 'notationPageState',
            storage,
            blacklist: [
                'error',
                'networkError',
                'sendFormError',
                'enablePushNotation'
            ]
        },
        notationPageReducer
    )

    const democraticBurgerPersistReducer = persistReducer(
        {
            key: 'democraticBurgerPageState',
            storage,
            blacklist: ['error', 'networkError', 'dataElectionLoading']
        },
        democraticBurgerPageReducer
    )

    const storeLocatorPersistReducer = persistReducer(
        {
            key: 'pageStoreLocatorReducer',
            storage,
            whitelist: [
                'center',
                'defaultCenter',
                'nearbyRestaurant',
                'userPosition'
            ],
            blacklist: ['geocodingError', 'error']
        },
        pageStoreLocatorReducer
    )

    const genericOperationPersistReducer = persistReducer(
        {
            key: 'genericOperationPageState',
            storage,
            blacklist: ['error', 'networkError']
        },
        genericOperationPageReducer
    )

    const kingdomPointsPersistReducer = persistReducer(
        {
            key: 'kingdomPointsPageState',
            storage,
            blacklist: ['error', 'networkError']
        },
        kingdomPointsPageReducer
    )

    const ecommerceOrderPersistReducer = persistReducer(
        {
            key: 'EcommerceOrderState',
            storage
        },
        ecommerceOrderReducer
    )

    const applicationPersistReducer = persistReducer(
        {
            key: 'applicationState',
            storage,
            whitelist: [
                'pointsPerEuroClickAndCollect, pointsPerEuroDeliveryInApp, pointsPerEuroTableOrder'
            ]
        },
        applicationReducer
    )

    const dealsPersistReducer = persistReducer(
        {
            key: 'dealsPageState',
            storage,
            blacklist: ['dealsError', 'dealsNetworkError']
        },
        dealsPageReducer
    )

    const menuPersistReducer = persistReducer(
        {
            key: 'menuPageState',
            storage,
            blacklist: ['error', 'networkError']
        },
        menuPageReducer
    )

    return {
        applicationState: applicationPersistReducer,
        homePageState: homePersistReducer,
        franchisePageState: franchisePersistReducer,
        storeLocatorPageState: storeLocatorPersistReducer,
        productPageState: productPageReducer,
        familyPageState: familyPersistReducer,
        i18nState: i18nReducer,
        metaDataState: metaDataReducer,
        notFoundPageState: notFoundPersistReducer,
        uiState: uiReducer,
        categoriesPageState: categoriesPageReducer,
        faqPageState: faqPersistReducer,
        userState: userPersistReducer,
        customPageState: customPersistReducer,
        timelinePageState: timelinePageReducer,
        rootPageState: rootPersistReducer,
        orbState: orbPersistReducer,
        signupPageState: signupPersistReducer,
        signinPageState: signinPersistReducer,
        congratulationsPageState: congratulationsPageReducer,
        resetPasswordPageState: resetPasswordPageReducer,
        kingdomCardPageState: kingdomCardPersistReducer,
        kingdomDashboardPageState: kingdomDashboardPersistReducer,
        kingdomProfilePageState: kingdomProfilePersistReducer,
        kingdomBlazonsPageState: kingdomBlazonsPersistReducer,
        kingdomPrivilegesPageState: kingdomPrivilegesPersistReducer,
        kingdomLotteryPageState: kingdomLotteryPageReducer,
        deliveryPageState: deliveryPersistReducer,
        mysteryBurgerPageState: mysteryBurgerPersistReducer,
        restaurantPageState: restaurantPageReducer,
        notationPageState: notationPersistReducer,
        democraticBurgerPageState: democraticBurgerPersistReducer,
        birthdayPageState: birthdayPageReducer,
        genericOperationPageState: genericOperationPersistReducer,
        kingdomPointsPageState: kingdomPointsPersistReducer,
        featuresState: featuresReducer,
        ecommerceOrderState: ecommerceOrderPersistReducer,
        ecommerceCatalogState: ecommerceCatalogReducer,
        satisfactionPageState: satisfactionPageReducer,
        futureWhopperPageState: futureWhopperPageReducer,
        veggieKingPageState: veggieKingPageReducer,
        dealsPageState: dealsPersistReducer,
        dealsWinningFormPageState: dealsWinningFormReducer,
        menuPageState: menuPersistReducer,
        tuPreferesKingState: tuPreferesKingReducer
    }
}

export { createRootReducer }
